<template>
    <div :class="{'is-invalid': invalid}">
        <select
            :disabled="disabled"
            :class="className"
            :name="name"
            ref="countrySelect"
        ><option></option></select>
    </div>
</template>
<script>

    export default {
        name   : 'CountrySelect',
        data() {
            return {
                // countries: null,
            };
        },
        props  : {
            name: {
                type   : String,
                default: 'country',
            },
            value: {
                default: null,
            },
            invalid: {
                type: Boolean,
                default: false,
            },
            selectCallback: {
                type   : Function,
                default: () => {},
            },
            className: {
                type   : String,
                default: 'form-control',
            },
            euOnly: {
                type: Boolean,
                default: false,
            },
            small: {
                type: Boolean,
                default: false,
            },
            returnIso: {
                type: Boolean,
                default: false,
            },
            allowClear: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            }
        },
        mounted() {
            if (!this.countries) {
                this.$store.dispatch('loadCountries');
            } else {
                this.updateCountries();
            }
        },
        computed: {
            countries() {
                let list;
                if (this.euOnly && this.$store.state.countries && this.$store.state.countries.filter) {
                    list = this.$store.state.countries.filter(function(item) {
                        return item.eumember;
                    });
                } else {
                    list = this.$store.state.countries;
                }

                if (list && list.map && this.returnIso) {
                    list = list.map(function (item) {
                        return {
                            id: item.iso,
                            text: item.text,
                        };
                    });
                }

                return list;
            }
        },
        watch  : {
            countries() {
                this.updateCountries();
            },
            value(newValue) {
                $(this.$refs['countrySelect']).val(newValue).trigger('change.select2');
            }
        },
        methods: {
            updateCountries() {
                const select = $(this.$refs['countrySelect']);
                select.select2(
                    {
                        data             : this.countries,
                        containerCssClass: this.className,
                        containerCss     : {'height': 'auto'},
                        dropdownAutoWidth: true,
                        width            : 'auto',
                        selectionCssClass: 'select2--small',
                        dropdownCssClass: 'select2--small',
                        placeholder: 'Select an option',
                        allowClear: this.allowClear,
                    }
                );
                if (this.value) {
                    select.val(this.value).trigger('change.select2');
                }

                if (this.disabled) return;

                select.on('change', () => {
                    const data = select.select2('data');
                    if (data.length === 1) {
                        if (this.returnIso) {
                            this.selectCallback(data[0].id);
                        } else {
                            this.selectCallback(parseInt(data[0].id, 10));
                        }
                    }
                });
            }
        },
    }
</script>

<style lang="scss">
    .select2-selection.form-control-sm {
        padding-top: 0;
        padding-bottom: 0;
    }

    select.form-control:disabled {
        & + .select2 {
            .select2-selection {
                background-color: #ccc;
            }
            .select2-selection__arrow > b {
                display: none;
            }
        }
    }
</style>